var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "outer1 flex-col"
  }, [_c("div", {
    staticClass: "bd2 flex-row justify-between"
  }, [_c("div", {
    staticClass: "group1 flex-col",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    }
  })]), _c("span", {
    staticClass: "word1"
  }, [_vm._v(_vm._s(_vm.$t("Brochure")))])]), _c("div", {
    staticClass: "bd3 flex-col"
  }, [_c("div", {
    staticClass: "section1 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data01);
      }
    }
  }, [_vm._m(0), _c("span", {
    staticClass: "info2"
  }, [_vm._v("All New MG5")])]), _c("div", {
    staticClass: "section3 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data02);
      }
    }
  }, [_vm._m(1), _vm._m(2)]), _c("div", {
    staticClass: "section4 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data03);
      }
    }
  }, [_vm._m(3), _vm._m(4)]), _c("div", {
    staticClass: "section5 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data04);
      }
    }
  }, [_vm._m(5), _c("span", {
    staticClass: "info3"
  }, [_vm._v("New MG EP Plus")])]), _c("div", {
    staticClass: "section5 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data05);
      }
    }
  }, [_vm._m(6), _c("span", {
    staticClass: "info3"
  }, [_vm._v("MG ZS EV MCE")])]), _c("div", {
    staticClass: "section5 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data06);
      }
    }
  }, [_vm._m(7), _c("span", {
    staticClass: "info3"
  }, [_vm._v("New MG VS HEV")])]), _c("div", {
    staticClass: "section5 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data07);
      }
    }
  }, [_vm._m(8), _c("span", {
    staticClass: "info3"
  }, [_vm._v("New MG HS")])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section2 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_new_mg5.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "group2 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_new_mg_extenderdc.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "group3"
  }, [_c("span", {
    staticClass: "paragraph1"
  }, [_vm._v("New MG Extender"), _c("br")]), _c("span", {
    staticClass: "txt1"
  }, [_vm._v("(DC)")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wrap4 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_new_mg_extendergc.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wrap5"
  }, [_c("span", {
    staticClass: "infoBox1"
  }, [_vm._v("New MG Extender"), _c("br")]), _c("span", {
    staticClass: "word2"
  }, [_vm._v("(GC)")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "group4 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "29vw",
      width: "50vw",
      "margin-top": "5vw"
    },
    attrs: {
      src: require("../../assets/images/car_new_mg_ep_plus.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section2 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_mg_zsev_mce.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section2 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_mg_vs_hev.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section2 flex-col"
  }, [_c("img", {
    staticStyle: {
      height: "35vw",
      width: "50vw"
    },
    attrs: {
      src: require("../../assets/images/car_mg_hs.png")
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };